import { FeatureType } from "@/geoMap/define/FeatureType";
import { IAttributeConvert } from "./IAttributeConvert";
import { AttributeView } from "./AttributeView";
import { ExportValue } from "./ExportValue";
import GeoJSON from "ol/format/GeoJSON";

/**
 * 点検データ属性変換共通クラス
 */
export abstract class AbstructRoadStructuresAttributeConvert
  implements IAttributeConvert
{
  /**
   * 地物タイプ
   */
  abstract _featureType: FeatureType;

  /**
   * GeoJSONファイル名
   */
  protected abstract _jsonFileName: string;
  /**
   * CSVファイル名
   */
  protected abstract _csvFileName: string;

  /**
   * 対象GeoJSON
   */
  protected _geoJSON: any;

  /**
   * @constructor
   * @param geoJSON 点検データ属性JSON
   */
  constructor(geoJSON: any) {
    this._geoJSON = geoJSON;
  }

  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return this._featureType;
  }

  /**
   * 画面用フォーマットに変換
   */
  abstract getViewFormatData(): AttributeView;

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = new GeoJSON().readFeature(this._geoJSON);
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      this._jsonFileName,
      this._csvFileName
    );
  }
}
